export default __webpack_public_path__ + "static/media/Co.Durham2hrRapidResponseNursingTeamsGeneralGuidanceonRapidResponseNursingServices.4a49f09c.jpg";